import React from 'react';
import BosShowProvider from "./context/bo-show-context.jsx";
import BoShow from "./bo-show.jsx";

const BoShowIndex = () => {
    return (
        <BosShowProvider>
            <BoShow />
        </BosShowProvider>
    );
};

export default BoShowIndex;